import { SubPageBlueprint, createFrontendModule } from '@backstage/frontend-plugin-api';
import { Content } from '@backstage/core-components';

// Namespaced under 'user-settings' (not 'app') so this attaches to
// page:user-settings's `pages` input — SubPageBlueprint attaches by matching
// namespace, e.g. sub-page:user-settings/about -> page:user-settings.
const aboutSettingsPage = SubPageBlueprint.make({
  name: 'about',
  params: {
    path: 'about',
    title: 'About',
    loader: () =>
      import('./AboutSettingsPage').then(m => (
        <Content>
          <m.AboutSettingsPage />
        </Content>
      )),
  },
});

export const settingsModule = createFrontendModule({
  pluginId: 'user-settings',
  extensions: [aboutSettingsPage],
});
